export default class WinState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click, this);
			this.spinButton.clickEvent.add(this.spin_Click, this);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown, this);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown, this);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click, this);
		}
		this.slotControls.setSpinButtonText(this.slotControls.freeSpins > 0 ? this.slotControls.freeSpins : 'SPIN');

		// control activity
		this.slotControls.setControlActivity(false, this.slotControls.auto, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		if (this.stateObject.isCascadeSpin)
			this.stateObject.winShow(() => {
				this.stateMachine.changeState(this.stateObject.preSpinState);
			});
		// winshow -> prespin state -> cascade spin
		else
			this.stateObject.winShow(() => {
				this.stateMachine.changeState(this.stateObject.freeInputWinState);
			});
	}

	exitTo(newState) {
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	//region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {
		if (this.slotControls.auto) {
			this.slotControls.resetAutoSpinsMode();
			this.slotControls.setControlActivity(false, this.slotControls.auto, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
			return;
		}
	}

	spin_Click() {
		if (this.slotControls.auto) {
			this.slotControls.resetAutoSpinsMode();
			this.slotControls.setControlActivity(false, this.slotControls.auto, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
			return;
		}
	}

	autoSpin_Click() {
		if (this.slotControls.auto) {
			this.slotControls.resetAutoSpinsMode();
			this.slotControls.setControlActivity(false, this.slotControls.auto, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
			return;
		}
	}
	//endregion input

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'WinState';
	}
}
